export default __webpack_public_path__ + "48a63e4131311b5de4c4b61e0e42903f.png";